import React from "react";
import { Badge } from "react-bootstrap";

interface IProps {
    content?: string | number;
}

class BaseBadge extends React.Component<IProps> {
    public render(): JSX.Element {
        const { content } = this.props;

        return content !== undefined ? (
            <Badge className="notification rounded-circle bg-ccq-blue text-white">{content}</Badge>
        ) : (
            <></>
        );
    }
}

export { BaseBadge as Unconnected };
export default BaseBadge;
